import { ModalSizeType, ModalSize } from './types';

export const modal: { [key in ModalSizeType]: ModalSize } = {
  sm: {
    width: 480,
  },
  md: {
    width: 590,
  },
  lg: {
    width: 900,
  },
  xl: {
    width: 1096,
  },
};
